import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';
import '../styles/SharedStyles.css';

const Auth = () => {
  const [isLogin, setIsLogin] = useState(true);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  const { t } = useLanguage();
  const { login, register, user } = useAuth();
  const { theme } = useTheme();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    try {
      if (isLogin) {
        const res = await login(email.trim(), password);
        if (res.success) {
          const targetPath = res.user.role === 'admin'
            ? '/admin'
            : res.user.status === 'active'
              ? '/servers'
              : '';

          if (res.user.role === 'admin') {
            navigate(targetPath, { replace: true });
            window.location.hash = targetPath;
          } else if (res.user.status === 'active') {
            navigate(targetPath, { replace: true });
            window.location.hash = targetPath;
          } else {
            setMessage(t('accountPending'));
          }
        } else {
          setError(t(res.error) !== res.error ? t(res.error) : res.error);
        }
      } else {
        const res = await register(email.trim(), password);
        if (res.success) {
          setMessage(t('registerSuccess'));
          setIsLogin(true);
          setEmail('');
          setPassword('');
        } else {
          setError(res.error);
        }
      }
    } catch (err) {
      setError(t('serverError'));
      console.error('Auth request failed', err);
    }
  };

  if (user && user.status === 'pending') {
    return (
      <div className={`shared-page ${theme}`}>
        <div className="glow-effect glow-1"></div>
        <div className="glow-effect glow-2"></div>
        <div className="container shared-content" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '80vh' }}>
          <div className="auth-card text-center">
            <div className="auth-card-icon" style={{ background: 'linear-gradient(135deg, #f59e0b 0%, #ef4444 100%)' }}>⚠</div>
            <h2 style={{ color: '#f59e0b', marginBottom: '1rem' }}>{t('accountPending')}</h2>
            <p style={{ color: '#94a3b8', marginBottom: '1.5rem' }}>Your account is awaiting approval</p>
            <button className="btn btn-primary" onClick={() => navigate('/')}>{t('backToHome')}</button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`shared-page ${theme}`}>
      <div className="glow-effect glow-1"></div>
      <div className="glow-effect glow-2"></div>
      <div className="container shared-content" style={{ paddingTop: '4rem', paddingBottom: '4rem' }}>

      <div className="shared-section-header">
        <h2>{isLogin ? t('login') : t('register')}</h2>
        <p>{t('usersPageSubtitle')}</p>
      </div>

      <div className="auth-card">
        <div className="auth-card-icon" style={{ background: 'linear-gradient(135deg, #0ea5e9 0%, #7c3aed 100%)' }}>
          {isLogin ? '🔐' : '🚀'}
        </div>

        {error && <div className="auth-alert auth-alert-error">{error}</div>}
        {message && <div className="auth-alert auth-alert-success">{message}</div>}

        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <label>{t('email')}</label>
            <input
              type="text"
              className="input-control"
              value={email}
              onChange={e => setEmail(e.target.value)}
              autoComplete="username"
              required
              placeholder="Enter your email"
            />
          </div>
          <div className="input-group">
            <label>{t('password')}</label>
            <input
              type="password"
              className="input-control"
              value={password}
              onChange={e => setPassword(e.target.value)}
              autoComplete={isLogin ? 'current-password' : 'new-password'}
              required
              placeholder="Enter your password"
            />
          </div>
          <button type="submit" className="btn btn-primary w-full" style={{ padding: '0.875rem', fontSize: '1rem' }}>
            {isLogin ? t('login') : t('register')}
          </button>
        </form>

        <div className="auth-divider">
          <span>OR</span>
        </div>

        <button
          type="button"
          className="btn btn-outline w-full"
          onClick={() => { setIsLogin(!isLogin); setError(''); setMessage(''); }}
        >
          {isLogin ? t('register') : t('login')}
        </button>
      </div>
      </div>
    </div>
  );
};

export default Auth;
